import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import Entity from "../datasource/Entity";
import axios from "axios";

import Container from "./Container.jsx";

class InterfacesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("interfaces");
        this.state = {
            interfaceTypes: [],
            payment_methods: []
        };
    }

    componentDidMount() {
        axios
            .get("/manager/data/interface_types")
            .then((res) => {
                this.setState({ interfaceTypes: res.data });
            })
            .catch((error) => {
                console.error(error);
            });

        axios.get('/manager/data/payment_methods')
            .then(res => {
                const payment_methods = res.data.map( p => {
                    return p.name;
                })
                this.setState({ payment_methods });
            })
            .catch(error => {
                console.error(error);
            });
    }

    render = () => {
        const notPermitted = this.checkAvailability();
        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const defaultHotels = this.props.defaultHotels?.map((hotel) => ({
            id: hotel.id,
            name: hotel.name,
            active: hotel.active,
        }));

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={"Список интерфейсов"}
                        columns={{
                            id: "Id",
                            name: "Имя",
                            code: "Код",
                            description: "Описание",
                            active: "Активен",
                            synchronize_quotas: "Синхронизировать квоты",
                            automatic_exchange: "Автоматический обмен",
                            sync_asu: "Синхронизации цен с АСУ",
                            hotel_id: "Отель",
                            interface_type_id: "Типа интерфейса",
                            external_url: "Юрл внешний",
                            internal_url: "Юрл внутренний",
                            travel_agent_name: "Имя агента",
                            travel_agent_id: "Ид агента",
                            source_name: "Имя источника",
                            source_id: "Ид источника",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        getHotelsAction={this.getHotelsData}
                        hotelsData={this.state.hotelsData}
                        fields={fields}
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новый интерфейс"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        defaultHotels={defaultHotels}
                        interfaceTypes={this.state.interfaceTypes}
                        payment_methods={this.state?.payment_methods}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        title="Редактирование интерфейса"
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        defaultHotels={defaultHotels}
                        interfaceTypes={this.state.interfaceTypes}
                        payment_methods={this.state?.payment_methods}
                        thisInterface={true}
                    />
                </Route>
            </Switch>
        );
    };
}

export default InterfacesContainer;
